// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
    "limit": 10,
    "offset": 0,
    "live_orders": [
         {
            "order_crn": "CR51922035",
            "geo_region_id": null,
            "order_status": "LIVE",
            "order_created_at": 1719228428495,
            "type": "Courier",
            "service_details": {
                "vehicle_id": null,
                "name": "All India Parcel",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/ni-images/icon-images/courier.png",
                "service_type": "Courier"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Koushal Kalal",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "test",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Whitefield Main Rd, Thigalarapalya, Krishnarajapuram, Bengaluru, Karnataka 560067, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "test",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "test",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Hosur Rd, Chikku Lakshmaiah Layout, Koramangala, Bengaluru, Karnataka 560095, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 0.0
            },
            "tracking_link": null,
            "payment_mode": null,
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
      {
            "order_crn": "CRN1706262590",
            "geo_region_id": 3,
            "order_status": "LIVE",
            "order_created_at": 1713523201000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 2,
                "name": "Tata 407",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Tata_407_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Sushil  B",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": null,
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "684, Sector 3, HSR Layout, Bengaluru, Karnataka 560102, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9351929,
                        "long": 77.62448069999999
                    },
                    "contact": {
                        "name": "Sushil  B",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Prestige",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Koramangala,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 869.0
            },
            "tracking_link": "oms-staging-1.porter.in/rd/ebc8488d71",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN1202379990",
            "geo_region_id": 3,
            "order_status": "LIVE",
            "order_created_at": 1713522523000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9258611,
                        "long": 77.6001295
                    },
                    "contact": {
                        "name": "Sushil  B",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": null,
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "2, 1st Cross Rd, NAL Layout, 4th T Block East, Tilak Nagar, Jayanagar, Bengaluru, Karnataka 560041, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9351929,
                        "long": 77.62448069999999
                    },
                    "contact": {
                        "name": "Dwarika",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Prestige",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Koramangala,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 400.0
            },
            "tracking_link": "oms-staging-1.porter.in/rd/ec154dcc95",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        },
    ],
    "past_orders": [
        {
            "order_crn": "CRN1163892395",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712728800000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 9,
                "name": "Pickup 8ft",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Pickup_8ft_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "HSR Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9165757,
                        "long": 77.6101163
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "BTM Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 392.55
            },
            "tracking_link": "oms-staging-1.porter.in/rd/693c6ad109",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN1010844553",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712664234000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Baalkrishan Kapoor",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "HSR Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9165757,
                        "long": 77.6101163
                    },
                    "contact": {
                        "name": "Baalkrishan Kapoor",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "BTM Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 218.91
            },
            "tracking_link": "oms-staging-1.porter.in/rd/c5b5270469",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        },
        {
            "order_crn": "CRN1389240749",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712581759000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "HSR Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9165757,
                        "long": 77.6101163
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "BTM Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 218.91
            },
            "tracking_link": "oms-staging-1.porter.in/rd/57a63c07df",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        },
        {
            "order_crn": "CRN1990633514",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712581474000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 24,
                "name": "3 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/3_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "HSR Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9165757,
                        "long": 77.6101163
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "BTM Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 128.57
            },
            "tracking_link": "oms-staging-1.porter.in/rd/da796c9b98",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN1192998940",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712310018000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 2,
                "name": "Tata 407",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Tata_407_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Dwarika",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Majestic Views",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "HSR Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9165757,
                        "long": 77.6101163
                    },
                    "contact": {
                        "name": "Dwarika",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Glass Onion",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "BTM Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 822.66
            },
            "tracking_link": "oms-staging-1.porter.in/rd/6e5615f919",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN1040576791",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712227886000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 24,
                "name": "3 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/3_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "HSR Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9165757,
                        "long": 77.6101163
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "BTM Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 128.57
            },
            "tracking_link": "oms-staging-1.porter.in/rd/999e3b0de8",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN1634692764",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712225940000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 2,
                "name": "Tata 407",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Tata_407_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9121181,
                        "long": 77.6445548
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "HSR Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9165757,
                        "long": 77.6101163
                    },
                    "contact": {
                        "name": "Sushil",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "BTM Layout,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 810.41
            },
            "tracking_link": "oms-staging-1.porter.in/rd/ab8a04e58f",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN1068460799",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712208071000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 12.9259626,
                        "long": 77.6001086
                    },
                    "contact": {
                        "name": "Sushil  B",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": null,
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "17, Bannerghatta Rd, NAL Layout, 4th T Block East, Tilak Nagar, Jayanagar, Bengaluru, Karnataka 560041, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 12.9351929,
                        "long": 77.62448069999999
                    },
                    "contact": {
                        "name": "Dwarika",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Prestige",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Koramangala,  Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 221.66
            },
            "tracking_link": "oms-staging-1.porter.in/rd/42522dcaae",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        }
    ]
};

export {
  dummyResponse ,
}
/* No side effect */
